import LoginScreenConnector from './LoginScreenConnector';

export default LoginScreenConnector;
